var map = {
	"./once_ar.png": "8eb3",
	"./once_cn.png": "969a",
	"./once_de.png": "c1f3",
	"./once_en.png": "37c7",
	"./once_es.png": "bc2f",
	"./once_fr.png": "fa4b",
	"./once_ru.png": "ea74",
	"./once_zh.png": "0a8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb09";